import {isNilOrEmpty} from 'ramda-adjunct';

import {
  GetServiceOrderIntegrationsApiResponse,
  useGetServiceCaseIntegrationsEvaClaimAdditionalInformationQuery,
} from '@dms/api/workshop';

import {useIntegrationsEnabled} from '../../../hooks/useIntegrationsEnabled';

interface UseOrderAdditionalInformationSectionsProps {
  serviceCaseId: string;
  orderId: string;
  orderIntegrations?: GetServiceOrderIntegrationsApiResponse;
}

export function useOrderAdditionalInformationSections(
  props: UseOrderAdditionalInformationSectionsProps
) {
  const {
    isClaraIntegrationEnabled,
    isEvaClaimIntegrationEnabled,
    isMazdaIntegrationEnabled,
    isLoading: isIntegrationsLoading,
    isError: isIntegrationsError,
  } = useIntegrationsEnabled({
    serviceCaseId: props.serviceCaseId,
    orderIntegrations: props.orderIntegrations,
  });

  // The EVA section renders nothing when its data cannot be loaded, so the segment must follow.
  const {isError: isEvaInformationError, isLoading: isEvaInformationLoading} =
    useGetServiceCaseIntegrationsEvaClaimAdditionalInformationQuery(
      {serviceCaseId: props.serviceCaseId, serviceOrderId: props.orderId},
      {skip: !isEvaClaimIntegrationEnabled || isNilOrEmpty(props.orderId)}
    );

  const isClaraVisible = !!isClaraIntegrationEnabled;
  const isEvaVisible = !!isEvaClaimIntegrationEnabled && !isEvaInformationError;
  const isMazdaVisible = !!isMazdaIntegrationEnabled;

  return {
    isClaraVisible,
    isEvaVisible,
    isMazdaVisible,
    hasAnySection: isClaraVisible || isEvaVisible || isMazdaVisible,
    isLoading: isIntegrationsLoading || isEvaInformationLoading,
    isError: isIntegrationsError,
  };
}
